import { ApiData } from 'states/types'
import { NivosNews } from 'types/nivos-news'

const Types = {
  SET: '@@nivos-news/SET',
  ADD: '@@nivos-news/ADD',
  UPDATE: '@@nivos-news/UPDATE',
  LOADING: '@@nivos-news/LOADING',
  DELETE: '@@nivos-news/DELETE'
}

export type Payload = ApiData<NivosNews>

export { Types }
